import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { SharedModule } from '@shared/shared.module';
import { AvatarComponent } from 'app/ui/avatar/avatar.component';
import { NotificationsState } from 'app/view/notifications/store/notifications.state';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TopBarComponent } from './component/top-bar/top-bar.component';
import { SideMenuComponent } from '@core/navigation/component/side-menu/side-menu.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@NgModule({
  declarations: [
    TopBarComponent,
    SideMenuComponent
  ],
  exports: [
    TopBarComponent,
    SideMenuComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CollapseModule,
    PopoverModule,
    AvatarComponent,
    BsDropdownModule,
    NgxsModule.forFeature([
      NotificationsState
    ]),
    CdkTrapFocus
  ]
})
export class NavigationModule {
}
